export const assetMap = {
  "icons": {
    "icon-account-linking-failed-rebranding.svg": {
      "name": "icon-account-linking-failed-rebranding",
      "hashedName": "icon-account-linking-failed-rebranding.a023d24aa2cb",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-account-linking-failed-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-account-linking-failed-rebranding.a023d24aa2cb.svg"
      }
    },
    "icon-account-linking-failed.svg": {
      "name": "icon-account-linking-failed",
      "hashedName": "icon-account-linking-failed.a2d2bb0bea72",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-account-linking-failed.svg",
        "hashedPath": "icons/suffixed/icon-account-linking-failed.a2d2bb0bea72.svg"
      }
    },
    "icon-arrow-down.svg": {
      "name": "icon-arrow-down",
      "hashedName": "icon-arrow-down.c995d3f5b95a",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-down.svg",
        "hashedPath": "icons/suffixed/icon-arrow-down.c995d3f5b95a.svg"
      }
    },
    "icon-arrow-right-gradient-rebranding.svg": {
      "name": "icon-arrow-right-gradient-rebranding",
      "hashedName": "icon-arrow-right-gradient-rebranding.82f98b6eff25",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right-gradient-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right-gradient-rebranding.82f98b6eff25.svg"
      }
    },
    "icon-arrow-right-gradient.svg": {
      "name": "icon-arrow-right-gradient",
      "hashedName": "icon-arrow-right-gradient.3d22fc83d4ad",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right-gradient.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right-gradient.3d22fc83d4ad.svg"
      }
    },
    "icon-arrow-right-rebranding.svg": {
      "name": "icon-arrow-right-rebranding",
      "hashedName": "icon-arrow-right-rebranding.d121caadf5a0",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right-rebranding.d121caadf5a0.svg"
      }
    },
    "icon-arrow-right-red.svg": {
      "name": "icon-arrow-right-red",
      "hashedName": "icon-arrow-right-red.b2787281cfd0",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right-red.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right-red.b2787281cfd0.svg"
      }
    },
    "icon-arrow-right-white.svg": {
      "name": "icon-arrow-right-white",
      "hashedName": "icon-arrow-right-white.7fa6aeef0a55",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right-white.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right-white.7fa6aeef0a55.svg"
      }
    },
    "icon-arrow-right.svg": {
      "name": "icon-arrow-right",
      "hashedName": "icon-arrow-right.74617c14a4ab",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-arrow-right.svg",
        "hashedPath": "icons/suffixed/icon-arrow-right.74617c14a4ab.svg"
      }
    },
    "icon-autosweep-success-rebranding.svg": {
      "name": "icon-autosweep-success-rebranding",
      "hashedName": "icon-autosweep-success-rebranding.f5b41aa7dab4",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-autosweep-success-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-autosweep-success-rebranding.f5b41aa7dab4.svg"
      }
    },
    "icon-autosweep-success.svg": {
      "name": "icon-autosweep-success",
      "hashedName": "icon-autosweep-success.c5f7527ca1cf",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-autosweep-success.svg",
        "hashedPath": "icons/suffixed/icon-autosweep-success.c5f7527ca1cf.svg"
      }
    },
    "icon-back.svg": {
      "name": "icon-back",
      "hashedName": "icon-back.b8a096525d9e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-back.svg",
        "hashedPath": "icons/suffixed/icon-back.b8a096525d9e.svg"
      }
    },
    "icon-cash-autosweep-rebranding.svg": {
      "name": "icon-cash-autosweep-rebranding",
      "hashedName": "icon-cash-autosweep-rebranding.8f2201835598",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-cash-autosweep-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-cash-autosweep-rebranding.8f2201835598.svg"
      }
    },
    "icon-cash-autosweep.svg": {
      "name": "icon-cash-autosweep",
      "hashedName": "icon-cash-autosweep.160b11a180d5",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-cash-autosweep.svg",
        "hashedPath": "icons/suffixed/icon-cash-autosweep.160b11a180d5.svg"
      }
    },
    "icon-check.svg": {
      "name": "icon-check",
      "hashedName": "icon-check.db8cead026c9",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-check.svg",
        "hashedPath": "icons/suffixed/icon-check.db8cead026c9.svg"
      }
    },
    "icon-chevron-down.svg": {
      "name": "icon-chevron-down",
      "hashedName": "icon-chevron-down.4a49ee307525",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-down.svg",
        "hashedPath": "icons/suffixed/icon-chevron-down.4a49ee307525.svg"
      }
    },
    "icon-chevron-right.svg": {
      "name": "icon-chevron-right",
      "hashedName": "icon-chevron-right.95b5f863bb77",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-chevron-right.svg",
        "hashedPath": "icons/suffixed/icon-chevron-right.95b5f863bb77.svg"
      }
    },
    "icon-clock.svg": {
      "name": "icon-clock",
      "hashedName": "icon-clock.22347c8130f8",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-clock.svg",
        "hashedPath": "icons/suffixed/icon-clock.22347c8130f8.svg"
      }
    },
    "icon-close-rebranding.svg": {
      "name": "icon-close-rebranding",
      "hashedName": "icon-close-rebranding.773c5b9def1f",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-close-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-close-rebranding.773c5b9def1f.svg"
      }
    },
    "icon-close.svg": {
      "name": "icon-close",
      "hashedName": "icon-close.fe3e10b6ab85",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-close.svg",
        "hashedPath": "icons/suffixed/icon-close.fe3e10b6ab85.svg"
      }
    },
    "icon-convert-points.svg": {
      "name": "icon-convert-points",
      "hashedName": "icon-convert-points.86c0dd375e6a",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-convert-points.svg",
        "hashedPath": "icons/suffixed/icon-convert-points.86c0dd375e6a.svg"
      }
    },
    "icon-deliver.svg": {
      "name": "icon-deliver",
      "hashedName": "icon-deliver.a60f96267a21",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-deliver.svg",
        "hashedPath": "icons/suffixed/icon-deliver.a60f96267a21.svg"
      }
    },
    "icon-equal.svg": {
      "name": "icon-equal",
      "hashedName": "icon-equal.4b1ca58c7450",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-equal.svg",
        "hashedPath": "icons/suffixed/icon-equal.4b1ca58c7450.svg"
      }
    },
    "icon-error-rebranding.svg": {
      "name": "icon-error-rebranding",
      "hashedName": "icon-error-rebranding.6382c50470f4",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-error-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-error-rebranding.6382c50470f4.svg"
      }
    },
    "icon-error.svg": {
      "name": "icon-error",
      "hashedName": "icon-error.5fd49423be66",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-error.svg",
        "hashedPath": "icons/suffixed/icon-error.5fd49423be66.svg"
      }
    },
    "icon-failed-rebranding.svg": {
      "name": "icon-failed-rebranding",
      "hashedName": "icon-failed-rebranding.60f52e6e4889",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-failed-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-failed-rebranding.60f52e6e4889.svg"
      }
    },
    "icon-failed.svg": {
      "name": "icon-failed",
      "hashedName": "icon-failed.9697565d8129",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-failed.svg",
        "hashedPath": "icons/suffixed/icon-failed.9697565d8129.svg"
      }
    },
    "icon-filter.svg": {
      "name": "icon-filter",
      "hashedName": "icon-filter.92a9f3e47aa8",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-filter.svg",
        "hashedPath": "icons/suffixed/icon-filter.92a9f3e47aa8.svg"
      }
    },
    "icon-icn-transfer.svg": {
      "name": "icon-icn-transfer",
      "hashedName": "icon-icn-transfer.a5d795fd5fa2",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-icn-transfer.svg",
        "hashedPath": "icons/suffixed/icon-icn-transfer.a5d795fd5fa2.svg"
      }
    },
    "icon-increments.svg": {
      "name": "icon-increments",
      "hashedName": "icon-increments.3263e997e528",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-increments.svg",
        "hashedPath": "icons/suffixed/icon-increments.3263e997e528.svg"
      }
    },
    "icon-info-rebranding.svg": {
      "name": "icon-info-rebranding",
      "hashedName": "icon-info-rebranding.562a38b53f0a",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-info-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-info-rebranding.562a38b53f0a.svg"
      }
    },
    "icon-info.svg": {
      "name": "icon-info",
      "hashedName": "icon-info.d492a08c2a0c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-info.svg",
        "hashedPath": "icons/suffixed/icon-info.d492a08c2a0c.svg"
      }
    },
    "icon-linked-rebranding.svg": {
      "name": "icon-linked-rebranding",
      "hashedName": "icon-linked-rebranding.0ddbb8e5efe5",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-linked-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-linked-rebranding.0ddbb8e5efe5.svg"
      }
    },
    "icon-linked.svg": {
      "name": "icon-linked",
      "hashedName": "icon-linked.311662ea27ab",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-linked.svg",
        "hashedPath": "icons/suffixed/icon-linked.311662ea27ab.svg"
      }
    },
    "icon-loader.svg": {
      "name": "icon-loader",
      "hashedName": "icon-loader.2d27cb0c388e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-loader.svg",
        "hashedPath": "icons/suffixed/icon-loader.2d27cb0c388e.svg"
      }
    },
    "icon-location-pin.svg": {
      "name": "icon-location-pin",
      "hashedName": "icon-location-pin.50e0a53b4371",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-location-pin.svg",
        "hashedPath": "icons/suffixed/icon-location-pin.50e0a53b4371.svg"
      }
    },
    "icon-marker.svg": {
      "name": "icon-marker",
      "hashedName": "icon-marker.baf38e27455c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-marker.svg",
        "hashedPath": "icons/suffixed/icon-marker.baf38e27455c.svg"
      }
    },
    "icon-minimum-transfer.svg": {
      "name": "icon-minimum-transfer",
      "hashedName": "icon-minimum-transfer.0dc88a3556bf",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-minimum-transfer.svg",
        "hashedPath": "icons/suffixed/icon-minimum-transfer.0dc88a3556bf.svg"
      }
    },
    "icon-minus.svg": {
      "name": "icon-minus",
      "hashedName": "icon-minus.a95d1e79afbb",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-minus.svg",
        "hashedPath": "icons/suffixed/icon-minus.a95d1e79afbb.svg"
      }
    },
    "icon-no-linked-account-rebranding.svg": {
      "name": "icon-no-linked-account-rebranding",
      "hashedName": "icon-no-linked-account-rebranding.010f67d6f40d",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-no-linked-account-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-no-linked-account-rebranding.010f67d6f40d.svg"
      }
    },
    "icon-no-linked-account.svg": {
      "name": "icon-no-linked-account",
      "hashedName": "icon-no-linked-account.7eece365f063",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-no-linked-account.svg",
        "hashedPath": "icons/suffixed/icon-no-linked-account.7eece365f063.svg"
      }
    },
    "icon-noresultsgc-rebranding.svg": {
      "name": "icon-noresultsgc-rebranding",
      "hashedName": "icon-noresultsgc-rebranding.3185912e2379",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-noresultsgc-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-noresultsgc-rebranding.3185912e2379.svg"
      }
    },
    "icon-noresultsgc.svg": {
      "name": "icon-noresultsgc",
      "hashedName": "icon-noresultsgc.5c663829c79c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-noresultsgc.svg",
        "hashedPath": "icons/suffixed/icon-noresultsgc.5c663829c79c.svg"
      }
    },
    "icon-offer-category-beauty.svg": {
      "name": "icon-offer-category-beauty",
      "hashedName": "icon-offer-category-beauty.0bd71da2b132",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-beauty.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-beauty.0bd71da2b132.svg"
      }
    },
    "icon-offer-category-dining.svg": {
      "name": "icon-offer-category-dining",
      "hashedName": "icon-offer-category-dining.586b8cc5055a",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-dining.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-dining.586b8cc5055a.svg"
      }
    },
    "icon-offer-category-entertainment.svg": {
      "name": "icon-offer-category-entertainment",
      "hashedName": "icon-offer-category-entertainment.6ae6c8e4377f",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-entertainment.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-entertainment.6ae6c8e4377f.svg"
      }
    },
    "icon-offer-category-fashion.svg": {
      "name": "icon-offer-category-fashion",
      "hashedName": "icon-offer-category-fashion.f715fe55028b",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-fashion.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-fashion.f715fe55028b.svg"
      }
    },
    "icon-offer-category-health_and_beauty.svg": {
      "name": "icon-offer-category-health_and_beauty",
      "hashedName": "icon-offer-category-health_and_beauty.bd60202f798e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-health_and_beauty.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-health_and_beauty.bd60202f798e.svg"
      }
    },
    "icon-offer-category-lifestyle.svg": {
      "name": "icon-offer-category-lifestyle",
      "hashedName": "icon-offer-category-lifestyle.768dc2b8aa80",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-lifestyle.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-lifestyle.768dc2b8aa80.svg"
      }
    },
    "icon-offer-category-others.svg": {
      "name": "icon-offer-category-others",
      "hashedName": "icon-offer-category-others.39a52b2cb5ca",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-others.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-others.39a52b2cb5ca.svg"
      }
    },
    "icon-offer-category-retail.svg": {
      "name": "icon-offer-category-retail",
      "hashedName": "icon-offer-category-retail.a2dad6aef4ac",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-retail.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-retail.a2dad6aef4ac.svg"
      }
    },
    "icon-offer-category-tech.svg": {
      "name": "icon-offer-category-tech",
      "hashedName": "icon-offer-category-tech.fda1a3b3feea",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-tech.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-tech.fda1a3b3feea.svg"
      }
    },
    "icon-offer-category-travel.svg": {
      "name": "icon-offer-category-travel",
      "hashedName": "icon-offer-category-travel.af7117aa668e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-travel.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-travel.af7117aa668e.svg"
      }
    },
    "icon-offer-category-virgin-rebranding.svg": {
      "name": "icon-offer-category-virgin-rebranding",
      "hashedName": "icon-offer-category-virgin-rebranding.f7566f71616c",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-virgin-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-virgin-rebranding.f7566f71616c.svg"
      }
    },
    "icon-offer-category-virgin.svg": {
      "name": "icon-offer-category-virgin",
      "hashedName": "icon-offer-category-virgin.d2449f520acc",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-category-virgin.svg",
        "hashedPath": "icons/suffixed/icon-offer-category-virgin.d2449f520acc.svg"
      }
    },
    "icon-offer-listing-empty-rebranding.svg": {
      "name": "icon-offer-listing-empty-rebranding",
      "hashedName": "icon-offer-listing-empty-rebranding.a940bf3a072d",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-listing-empty-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-offer-listing-empty-rebranding.a940bf3a072d.svg"
      }
    },
    "icon-offer-listing-empty.svg": {
      "name": "icon-offer-listing-empty",
      "hashedName": "icon-offer-listing-empty.702acca99667",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-offer-listing-empty.svg",
        "hashedPath": "icons/suffixed/icon-offer-listing-empty.702acca99667.svg"
      }
    },
    "icon-pagination-right.svg": {
      "name": "icon-pagination-right",
      "hashedName": "icon-pagination-right.416d35fcb420",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-pagination-right.svg",
        "hashedPath": "icons/suffixed/icon-pagination-right.416d35fcb420.svg"
      }
    },
    "icon-phone.svg": {
      "name": "icon-phone",
      "hashedName": "icon-phone.17ea5bdec8a3",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-phone.svg",
        "hashedPath": "icons/suffixed/icon-phone.17ea5bdec8a3.svg"
      }
    },
    "icon-plane-rebranding.svg": {
      "name": "icon-plane-rebranding",
      "hashedName": "icon-plane-rebranding.3efe8cadb161",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-plane-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-plane-rebranding.3efe8cadb161.svg"
      }
    },
    "icon-plane.svg": {
      "name": "icon-plane",
      "hashedName": "icon-plane.4200ff8cae17",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-plane.svg",
        "hashedPath": "icons/suffixed/icon-plane.4200ff8cae17.svg"
      }
    },
    "icon-plus.svg": {
      "name": "icon-plus",
      "hashedName": "icon-plus.63082a9ccab8",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-plus.svg",
        "hashedPath": "icons/suffixed/icon-plus.63082a9ccab8.svg"
      }
    },
    "icon-points.svg": {
      "name": "icon-points",
      "hashedName": "icon-points.8b61f494ca48",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-points.svg",
        "hashedPath": "icons/suffixed/icon-points.8b61f494ca48.svg"
      }
    },
    "icon-progress.svg": {
      "name": "icon-progress",
      "hashedName": "icon-progress.06aded70c5ef",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-progress.svg",
        "hashedPath": "icons/suffixed/icon-progress.06aded70c5ef.svg"
      }
    },
    "icon-rc-arrow-down.svg": {
      "name": "icon-rc-arrow-down",
      "hashedName": "icon-rc-arrow-down.c1eae7ced689",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-rc-arrow-down.svg",
        "hashedPath": "icons/suffixed/icon-rc-arrow-down.c1eae7ced689.svg"
      }
    },
    "icon-rc-enrollments-empty-rebranding.svg": {
      "name": "icon-rc-enrollments-empty-rebranding",
      "hashedName": "icon-rc-enrollments-empty-rebranding.de4465ac59c7",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-rc-enrollments-empty-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-rc-enrollments-empty-rebranding.de4465ac59c7.svg"
      }
    },
    "icon-rc-enrollments-empty.svg": {
      "name": "icon-rc-enrollments-empty",
      "hashedName": "icon-rc-enrollments-empty.bbc1a1e80d35",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-rc-enrollments-empty.svg",
        "hashedPath": "icons/suffixed/icon-rc-enrollments-empty.bbc1a1e80d35.svg"
      }
    },
    "icon-search.svg": {
      "name": "icon-search",
      "hashedName": "icon-search.ffa1dd0381e1",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-search.svg",
        "hashedPath": "icons/suffixed/icon-search.ffa1dd0381e1.svg"
      }
    },
    "icon-share-points-empty-rebranding.svg": {
      "name": "icon-share-points-empty-rebranding",
      "hashedName": "icon-share-points-empty-rebranding.de4465ac59c7",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-share-points-empty-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-share-points-empty-rebranding.de4465ac59c7.svg"
      }
    },
    "icon-share-points-empty.svg": {
      "name": "icon-share-points-empty",
      "hashedName": "icon-share-points-empty.bbc1a1e80d35",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-share-points-empty.svg",
        "hashedPath": "icons/suffixed/icon-share-points-empty.bbc1a1e80d35.svg"
      }
    },
    "icon-sort.svg": {
      "name": "icon-sort",
      "hashedName": "icon-sort.e5cd284c264f",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-sort.svg",
        "hashedPath": "icons/suffixed/icon-sort.e5cd284c264f.svg"
      }
    },
    "icon-store.svg": {
      "name": "icon-store",
      "hashedName": "icon-store.708f2757d0d4",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-store.svg",
        "hashedPath": "icons/suffixed/icon-store.708f2757d0d4.svg"
      }
    },
    "icon-success.svg": {
      "name": "icon-success",
      "hashedName": "icon-success.357170ce3c7e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-success.svg",
        "hashedPath": "icons/suffixed/icon-success.357170ce3c7e.svg"
      }
    },
    "icon-tc-listing-empty-state-filter-rebranding.svg": {
      "name": "icon-tc-listing-empty-state-filter-rebranding",
      "hashedName": "icon-tc-listing-empty-state-filter-rebranding.1da25be8a883",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-tc-listing-empty-state-filter-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-tc-listing-empty-state-filter-rebranding.1da25be8a883.svg"
      }
    },
    "icon-tc-listing-empty-state-filter.svg": {
      "name": "icon-tc-listing-empty-state-filter",
      "hashedName": "icon-tc-listing-empty-state-filter.0930ffceb455",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-tc-listing-empty-state-filter.svg",
        "hashedPath": "icons/suffixed/icon-tc-listing-empty-state-filter.0930ffceb455.svg"
      }
    },
    "icon-unexpected-error-rebranding.svg": {
      "name": "icon-unexpected-error-rebranding",
      "hashedName": "icon-unexpected-error-rebranding.60f52e6e4889",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-unexpected-error-rebranding.svg",
        "hashedPath": "icons/suffixed/icon-unexpected-error-rebranding.60f52e6e4889.svg"
      }
    },
    "icon-unexpected-error.svg": {
      "name": "icon-unexpected-error",
      "hashedName": "icon-unexpected-error.b2045b4b78e2",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-unexpected-error.svg",
        "hashedPath": "icons/suffixed/icon-unexpected-error.b2045b4b78e2.svg"
      }
    },
    "icon-validity.svg": {
      "name": "icon-validity",
      "hashedName": "icon-validity.cc525b350d9e",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-validity.svg",
        "hashedPath": "icons/suffixed/icon-validity.cc525b350d9e.svg"
      }
    },
    "icon-warning.svg": {
      "name": "icon-warning",
      "hashedName": "icon-warning.632c21315845",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-warning.svg",
        "hashedPath": "icons/suffixed/icon-warning.632c21315845.svg"
      }
    },
    "icon-website.svg": {
      "name": "icon-website",
      "hashedName": "icon-website.00cd3b8e8638",
      "extension": "svg",
      "path": {
        "originalPath": "icons/icon-website.svg",
        "hashedPath": "icons/suffixed/icon-website.00cd3b8e8638.svg"
      }
    }
  },
  "images": {
    "1-rebranding.png": {
      "name": "1-rebranding",
      "hashedName": "1-rebranding.389f9499389c",
      "extension": "png",
      "path": {
        "originalPath": "images/1-rebranding.png",
        "hashedPath": "images/suffixed/1-rebranding.389f9499389c.png"
      }
    },
    "1.png": {
      "name": "1",
      "hashedName": "1.5f56c539618a",
      "extension": "png",
      "path": {
        "originalPath": "images/1.png",
        "hashedPath": "images/suffixed/1.5f56c539618a.png"
      }
    },
    "2-rebranding.png": {
      "name": "2-rebranding",
      "hashedName": "2-rebranding.dde96cf5f976",
      "extension": "png",
      "path": {
        "originalPath": "images/2-rebranding.png",
        "hashedPath": "images/suffixed/2-rebranding.dde96cf5f976.png"
      }
    },
    "2.png": {
      "name": "2",
      "hashedName": "2.fcda39b8e151",
      "extension": "png",
      "path": {
        "originalPath": "images/2.png",
        "hashedPath": "images/suffixed/2.fcda39b8e151.png"
      }
    },
    "3-rebranding.png": {
      "name": "3-rebranding",
      "hashedName": "3-rebranding.0860bde5b054",
      "extension": "png",
      "path": {
        "originalPath": "images/3-rebranding.png",
        "hashedPath": "images/suffixed/3-rebranding.0860bde5b054.png"
      }
    },
    "3.png": {
      "name": "3",
      "hashedName": "3.7d44dc0205f2",
      "extension": "png",
      "path": {
        "originalPath": "images/3.png",
        "hashedPath": "images/suffixed/3.7d44dc0205f2.png"
      }
    },
    "4-rebranding.png": {
      "name": "4-rebranding",
      "hashedName": "4-rebranding.32764c5b6bee",
      "extension": "png",
      "path": {
        "originalPath": "images/4-rebranding.png",
        "hashedPath": "images/suffixed/4-rebranding.32764c5b6bee.png"
      }
    },
    "4.png": {
      "name": "4",
      "hashedName": "4.32764c5b6bee",
      "extension": "png",
      "path": {
        "originalPath": "images/4.png",
        "hashedPath": "images/suffixed/4.32764c5b6bee.png"
      }
    },
    "GC-kv-desktop.avif": {
      "name": "GC-kv-desktop",
      "hashedName": "GC-kv-desktop.e09e6d32dc7e",
      "extension": "avif",
      "path": {
        "originalPath": "images/GC-kv-desktop.avif",
        "hashedPath": "images/suffixed/GC-kv-desktop.e09e6d32dc7e.avif"
      }
    },
    "GC-kv-desktop.jpg": {
      "name": "GC-kv-desktop",
      "hashedName": "GC-kv-desktop.b568e6895180",
      "extension": "jpg",
      "path": {
        "originalPath": "images/GC-kv-desktop.jpg",
        "hashedPath": "images/suffixed/GC-kv-desktop.b568e6895180.jpg"
      }
    },
    "GC-kv-desktop.webp": {
      "name": "GC-kv-desktop",
      "hashedName": "GC-kv-desktop.03b1888403cc",
      "extension": "webp",
      "path": {
        "originalPath": "images/GC-kv-desktop.webp",
        "hashedPath": "images/suffixed/GC-kv-desktop.03b1888403cc.webp"
      }
    },
    "GC-kv-mobile.avif": {
      "name": "GC-kv-mobile",
      "hashedName": "GC-kv-mobile.e09e6d32dc7e",
      "extension": "avif",
      "path": {
        "originalPath": "images/GC-kv-mobile.avif",
        "hashedPath": "images/suffixed/GC-kv-mobile.e09e6d32dc7e.avif"
      }
    },
    "GC-kv-mobile.jpg": {
      "name": "GC-kv-mobile",
      "hashedName": "GC-kv-mobile.b568e6895180",
      "extension": "jpg",
      "path": {
        "originalPath": "images/GC-kv-mobile.jpg",
        "hashedPath": "images/suffixed/GC-kv-mobile.b568e6895180.jpg"
      }
    },
    "GC-kv-mobile.webp": {
      "name": "GC-kv-mobile",
      "hashedName": "GC-kv-mobile.03b1888403cc",
      "extension": "webp",
      "path": {
        "originalPath": "images/GC-kv-mobile.webp",
        "hashedPath": "images/suffixed/GC-kv-mobile.03b1888403cc.webp"
      }
    },
    "OH_OfferImage.jpg": {
      "name": "OH_OfferImage",
      "hashedName": "OH_OfferImage.f2d60c362985",
      "extension": "jpg",
      "path": {
        "originalPath": "images/OH_OfferImage.jpg",
        "hashedPath": "images/suffixed/OH_OfferImage.f2d60c362985.jpg"
      }
    },
    "RC-kv-desktop.avif": {
      "name": "RC-kv-desktop",
      "hashedName": "RC-kv-desktop.536e69d37ad9",
      "extension": "avif",
      "path": {
        "originalPath": "images/RC-kv-desktop.avif",
        "hashedPath": "images/suffixed/RC-kv-desktop.536e69d37ad9.avif"
      }
    },
    "RC-kv-desktop.jpg": {
      "name": "RC-kv-desktop",
      "hashedName": "RC-kv-desktop.255b66952908",
      "extension": "jpg",
      "path": {
        "originalPath": "images/RC-kv-desktop.jpg",
        "hashedPath": "images/suffixed/RC-kv-desktop.255b66952908.jpg"
      }
    },
    "RC-kv-desktop.webp": {
      "name": "RC-kv-desktop",
      "hashedName": "RC-kv-desktop.f186a40b3108",
      "extension": "webp",
      "path": {
        "originalPath": "images/RC-kv-desktop.webp",
        "hashedPath": "images/suffixed/RC-kv-desktop.f186a40b3108.webp"
      }
    },
    "RC-kv-mobile.avif": {
      "name": "RC-kv-mobile",
      "hashedName": "RC-kv-mobile.536e69d37ad9",
      "extension": "avif",
      "path": {
        "originalPath": "images/RC-kv-mobile.avif",
        "hashedPath": "images/suffixed/RC-kv-mobile.536e69d37ad9.avif"
      }
    },
    "RC-kv-mobile.jpg": {
      "name": "RC-kv-mobile",
      "hashedName": "RC-kv-mobile.255b66952908",
      "extension": "jpg",
      "path": {
        "originalPath": "images/RC-kv-mobile.jpg",
        "hashedPath": "images/suffixed/RC-kv-mobile.255b66952908.jpg"
      }
    },
    "RC-kv-mobile.webp": {
      "name": "RC-kv-mobile",
      "hashedName": "RC-kv-mobile.f186a40b3108",
      "extension": "webp",
      "path": {
        "originalPath": "images/RC-kv-mobile.webp",
        "hashedPath": "images/suffixed/RC-kv-mobile.f186a40b3108.webp"
      }
    },
    "RC.jpg": {
      "name": "RC",
      "hashedName": "RC.10fb11e350b3",
      "extension": "jpg",
      "path": {
        "originalPath": "images/RC.jpg",
        "hashedPath": "images/suffixed/RC.10fb11e350b3.jpg"
      }
    },
    "TC-kv-desktop.avif": {
      "name": "TC-kv-desktop",
      "hashedName": "TC-kv-desktop.a6dec34e901a",
      "extension": "avif",
      "path": {
        "originalPath": "images/TC-kv-desktop.avif",
        "hashedPath": "images/suffixed/TC-kv-desktop.a6dec34e901a.avif"
      }
    },
    "TC-kv-desktop.jpg": {
      "name": "TC-kv-desktop",
      "hashedName": "TC-kv-desktop.ba28cd10b7f4",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC-kv-desktop.jpg",
        "hashedPath": "images/suffixed/TC-kv-desktop.ba28cd10b7f4.jpg"
      }
    },
    "TC-kv-desktop.webp": {
      "name": "TC-kv-desktop",
      "hashedName": "TC-kv-desktop.85fefe4ada15",
      "extension": "webp",
      "path": {
        "originalPath": "images/TC-kv-desktop.webp",
        "hashedPath": "images/suffixed/TC-kv-desktop.85fefe4ada15.webp"
      }
    },
    "TC-kv-mobile.avif": {
      "name": "TC-kv-mobile",
      "hashedName": "TC-kv-mobile.a6dec34e901a",
      "extension": "avif",
      "path": {
        "originalPath": "images/TC-kv-mobile.avif",
        "hashedPath": "images/suffixed/TC-kv-mobile.a6dec34e901a.avif"
      }
    },
    "TC-kv-mobile.jpg": {
      "name": "TC-kv-mobile",
      "hashedName": "TC-kv-mobile.ba28cd10b7f4",
      "extension": "jpg",
      "path": {
        "originalPath": "images/TC-kv-mobile.jpg",
        "hashedPath": "images/suffixed/TC-kv-mobile.ba28cd10b7f4.jpg"
      }
    },
    "TC-kv-mobile.webp": {
      "name": "TC-kv-mobile",
      "hashedName": "TC-kv-mobile.85fefe4ada15",
      "extension": "webp",
      "path": {
        "originalPath": "images/TC-kv-mobile.webp",
        "hashedPath": "images/suffixed/TC-kv-mobile.85fefe4ada15.webp"
      }
    },
    "arrow-l-L.svg": {
      "name": "arrow-l-L",
      "hashedName": "arrow-l-L.63a86a6ff243",
      "extension": "svg",
      "path": {
        "originalPath": "images/arrow-l-L.svg",
        "hashedPath": "images/suffixed/arrow-l-L.63a86a6ff243.svg"
      }
    },
    "arrow-s-D.svg": {
      "name": "arrow-s-D",
      "hashedName": "arrow-s-D.015de3b2aedd",
      "extension": "svg",
      "path": {
        "originalPath": "images/arrow-s-D.svg",
        "hashedPath": "images/suffixed/arrow-s-D.015de3b2aedd.svg"
      }
    },
    "dark-logo-rebranding.png": {
      "name": "dark-logo-rebranding",
      "hashedName": "dark-logo-rebranding.f1e5c2857c74",
      "extension": "png",
      "path": {
        "originalPath": "images/branding/dark-logo-rebranding.png",
        "hashedPath": "images/branding/suffixed/dark-logo-rebranding.f1e5c2857c74.png"
      }
    },
    "dark-logo.png": {
      "name": "dark-logo",
      "hashedName": "dark-logo.1cae0c0b4565",
      "extension": "png",
      "path": {
        "originalPath": "images/branding/dark-logo.png",
        "hashedPath": "images/branding/suffixed/dark-logo.1cae0c0b4565.png"
      }
    },
    "empty-bonus-offer.png": {
      "name": "empty-bonus-offer",
      "hashedName": "empty-bonus-offer.1457bcca6293",
      "extension": "png",
      "path": {
        "originalPath": "images/empty-bonus-offer.png",
        "hashedPath": "images/suffixed/empty-bonus-offer.1457bcca6293.png"
      }
    },
    "equal-icon-grey.svg": {
      "name": "equal-icon-grey",
      "hashedName": "equal-icon-grey.aa40bb307cab",
      "extension": "svg",
      "path": {
        "originalPath": "images/equal-icon-grey.svg",
        "hashedPath": "images/suffixed/equal-icon-grey.aa40bb307cab.svg"
      }
    },
    "flags-25-standard.png": {
      "name": "flags-25-standard",
      "hashedName": "flags-25-standard.8666ae55b0c8",
      "extension": "png",
      "path": {
        "originalPath": "images/flags/flags-25-standard.png",
        "hashedPath": "images/flags/suffixed/flags-25-standard.8666ae55b0c8.png"
      }
    },
    "gc-tile.jpg": {
      "name": "gc-tile",
      "hashedName": "gc-tile.1e311e33e07b",
      "extension": "jpg",
      "path": {
        "originalPath": "images/gc-tile.jpg",
        "hashedPath": "images/suffixed/gc-tile.1e311e33e07b.jpg"
      }
    },
    "icn-close-dark.svg": {
      "name": "icn-close-dark",
      "hashedName": "icn-close-dark.8be668b16a6d",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-close-dark.svg",
        "hashedPath": "images/suffixed/icn-close-dark.8be668b16a6d.svg"
      }
    },
    "icn-emptytransaction-rebranding.svg": {
      "name": "icn-emptytransaction-rebranding",
      "hashedName": "icn-emptytransaction-rebranding.636043429d54",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-emptytransaction-rebranding.svg",
        "hashedPath": "images/suffixed/icn-emptytransaction-rebranding.636043429d54.svg"
      }
    },
    "icn-emptytransaction.svg": {
      "name": "icn-emptytransaction",
      "hashedName": "icn-emptytransaction.477253e0ffdf",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-emptytransaction.svg",
        "hashedPath": "images/suffixed/icn-emptytransaction.477253e0ffdf.svg"
      }
    },
    "icn-noresultstcrc.svg": {
      "name": "icn-noresultstcrc",
      "hashedName": "icn-noresultstcrc.1681a61fd09a",
      "extension": "svg",
      "path": {
        "originalPath": "images/icn-noresultstcrc.svg",
        "hashedPath": "images/suffixed/icn-noresultstcrc.1681a61fd09a.svg"
      }
    },
    "number-1-rebranding.svg": {
      "name": "number-1-rebranding",
      "hashedName": "number-1-rebranding.637712e70ab0",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-1-rebranding.svg",
        "hashedPath": "images/suffixed/number-1-rebranding.637712e70ab0.svg"
      }
    },
    "number-1.svg": {
      "name": "number-1",
      "hashedName": "number-1.5c122f9700db",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-1.svg",
        "hashedPath": "images/suffixed/number-1.5c122f9700db.svg"
      }
    },
    "number-2-rebranding.svg": {
      "name": "number-2-rebranding",
      "hashedName": "number-2-rebranding.a57640ec35be",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-2-rebranding.svg",
        "hashedPath": "images/suffixed/number-2-rebranding.a57640ec35be.svg"
      }
    },
    "number-2.svg": {
      "name": "number-2",
      "hashedName": "number-2.89e2be84d54a",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-2.svg",
        "hashedPath": "images/suffixed/number-2.89e2be84d54a.svg"
      }
    },
    "number-3-rebranding.svg": {
      "name": "number-3-rebranding",
      "hashedName": "number-3-rebranding.51e9f8acc5cf",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-3-rebranding.svg",
        "hashedPath": "images/suffixed/number-3-rebranding.51e9f8acc5cf.svg"
      }
    },
    "number-3.svg": {
      "name": "number-3",
      "hashedName": "number-3.21beaff64fb7",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-3.svg",
        "hashedPath": "images/suffixed/number-3.21beaff64fb7.svg"
      }
    },
    "number-4-rebranding.svg": {
      "name": "number-4-rebranding",
      "hashedName": "number-4-rebranding.f1b9bbebd9d1",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-4-rebranding.svg",
        "hashedPath": "images/suffixed/number-4-rebranding.f1b9bbebd9d1.svg"
      }
    },
    "number-4.svg": {
      "name": "number-4",
      "hashedName": "number-4.d6af7b256ae6",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-4.svg",
        "hashedPath": "images/suffixed/number-4.d6af7b256ae6.svg"
      }
    },
    "number-5.svg": {
      "name": "number-5",
      "hashedName": "number-5.dae803fc2c56",
      "extension": "svg",
      "path": {
        "originalPath": "images/number-5.svg",
        "hashedPath": "images/suffixed/number-5.dae803fc2c56.svg"
      }
    },
    "offer-banner-desktop.avif": {
      "name": "offer-banner-desktop",
      "hashedName": "offer-banner-desktop.c306d7fd08f0",
      "extension": "avif",
      "path": {
        "originalPath": "images/offer-banner-desktop.avif",
        "hashedPath": "images/suffixed/offer-banner-desktop.c306d7fd08f0.avif"
      }
    },
    "offer-banner-desktop.jpg": {
      "name": "offer-banner-desktop",
      "hashedName": "offer-banner-desktop.935988158e7f",
      "extension": "jpg",
      "path": {
        "originalPath": "images/offer-banner-desktop.jpg",
        "hashedPath": "images/suffixed/offer-banner-desktop.935988158e7f.jpg"
      }
    },
    "offer-banner-desktop.webp": {
      "name": "offer-banner-desktop",
      "hashedName": "offer-banner-desktop.fc5b6455ae03",
      "extension": "webp",
      "path": {
        "originalPath": "images/offer-banner-desktop.webp",
        "hashedPath": "images/suffixed/offer-banner-desktop.fc5b6455ae03.webp"
      }
    },
    "offer-banner-mobile.avif": {
      "name": "offer-banner-mobile",
      "hashedName": "offer-banner-mobile.c306d7fd08f0",
      "extension": "avif",
      "path": {
        "originalPath": "images/offer-banner-mobile.avif",
        "hashedPath": "images/suffixed/offer-banner-mobile.c306d7fd08f0.avif"
      }
    },
    "offer-banner-mobile.jpg": {
      "name": "offer-banner-mobile",
      "hashedName": "offer-banner-mobile.935988158e7f",
      "extension": "jpg",
      "path": {
        "originalPath": "images/offer-banner-mobile.jpg",
        "hashedPath": "images/suffixed/offer-banner-mobile.935988158e7f.jpg"
      }
    },
    "offer-banner-mobile.webp": {
      "name": "offer-banner-mobile",
      "hashedName": "offer-banner-mobile.fc5b6455ae03",
      "extension": "webp",
      "path": {
        "originalPath": "images/offer-banner-mobile.webp",
        "hashedPath": "images/suffixed/offer-banner-mobile.fc5b6455ae03.webp"
      }
    },
    "offer-dashed-border.svg": {
      "name": "offer-dashed-border",
      "hashedName": "offer-dashed-border.9b0c6702cd52",
      "extension": "svg",
      "path": {
        "originalPath": "images/offer-dashed-border.svg",
        "hashedPath": "images/suffixed/offer-dashed-border.9b0c6702cd52.svg"
      }
    },
    "oh-tile.jpg": {
      "name": "oh-tile",
      "hashedName": "oh-tile.905e1ce7badf",
      "extension": "jpg",
      "path": {
        "originalPath": "images/oh-tile.jpg",
        "hashedPath": "images/suffixed/oh-tile.905e1ce7badf.jpg"
      }
    },
    "pe-tile.jpg": {
      "name": "pe-tile",
      "hashedName": "pe-tile.4b3724410991",
      "extension": "jpg",
      "path": {
        "originalPath": "images/pe-tile.jpg",
        "hashedPath": "images/suffixed/pe-tile.4b3724410991.jpg"
      }
    },
    "placeholder.png": {
      "name": "placeholder",
      "hashedName": "placeholder.980edc01a77f",
      "extension": "png",
      "path": {
        "originalPath": "images/placeholder.png",
        "hashedPath": "images/suffixed/placeholder.980edc01a77f.png"
      }
    },
    "purchase-eraser-hero.avif": {
      "name": "purchase-eraser-hero",
      "hashedName": "purchase-eraser-hero.fe3e56c7482c",
      "extension": "avif",
      "path": {
        "originalPath": "images/purchase-eraser-hero.avif",
        "hashedPath": "images/suffixed/purchase-eraser-hero.fe3e56c7482c.avif"
      }
    },
    "purchase-eraser-hero.jpg": {
      "name": "purchase-eraser-hero",
      "hashedName": "purchase-eraser-hero.4b3724410991",
      "extension": "jpg",
      "path": {
        "originalPath": "images/purchase-eraser-hero.jpg",
        "hashedPath": "images/suffixed/purchase-eraser-hero.4b3724410991.jpg"
      }
    },
    "purchase-eraser-hero.webp": {
      "name": "purchase-eraser-hero",
      "hashedName": "purchase-eraser-hero.8e6d9dd68b05",
      "extension": "webp",
      "path": {
        "originalPath": "images/purchase-eraser-hero.webp",
        "hashedPath": "images/suffixed/purchase-eraser-hero.8e6d9dd68b05.webp"
      }
    },
    "rc-tile.jpg": {
      "name": "rc-tile",
      "hashedName": "rc-tile.ea7a520fc5f3",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rc-tile.jpg",
        "hashedPath": "images/suffixed/rc-tile.ea7a520fc5f3.jpg"
      }
    },
    "arrow-down-red.svg": {
      "name": "arrow-down-red",
      "hashedName": "arrow-down-red.d47c4f765fd7",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/arrow-down-red.svg",
        "hashedPath": "images/rd/suffixed/arrow-down-red.d47c4f765fd7.svg"
      }
    },
    "arrow-l-R.svg": {
      "name": "arrow-l-R",
      "hashedName": "arrow-l-R.ed371bd15350",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/arrow-l-R.svg",
        "hashedPath": "images/rd/suffixed/arrow-l-R.ed371bd15350.svg"
      }
    },
    "arrow-l-blue-R.svg": {
      "name": "arrow-l-blue-R",
      "hashedName": "arrow-l-blue-R.5ed67cad7f48",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/arrow-l-blue-R.svg",
        "hashedPath": "images/rd/suffixed/arrow-l-blue-R.5ed67cad7f48.svg"
      }
    },
    "blue-arrow-down-with-border.png": {
      "name": "blue-arrow-down-with-border",
      "hashedName": "blue-arrow-down-with-border.7f6d0ce19f88",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/blue-arrow-down-with-border.png",
        "hashedPath": "images/rd/suffixed/blue-arrow-down-with-border.7f6d0ce19f88.png"
      }
    },
    "blue-arrow-down.png": {
      "name": "blue-arrow-down",
      "hashedName": "blue-arrow-down.5ffdeefd3a88",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/blue-arrow-down.png",
        "hashedPath": "images/rd/suffixed/blue-arrow-down.5ffdeefd3a88.png"
      }
    },
    "blue-arrow-left-with-border.png": {
      "name": "blue-arrow-left-with-border",
      "hashedName": "blue-arrow-left-with-border.5634ee921f50",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/blue-arrow-left-with-border.png",
        "hashedPath": "images/rd/suffixed/blue-arrow-left-with-border.5634ee921f50.png"
      }
    },
    "blue-arrow-right-with-border.png": {
      "name": "blue-arrow-right-with-border",
      "hashedName": "blue-arrow-right-with-border.5c9b89de8a2b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/blue-arrow-right-with-border.png",
        "hashedPath": "images/rd/suffixed/blue-arrow-right-with-border.5c9b89de8a2b.png"
      }
    },
    "blue-arrow-right.png": {
      "name": "blue-arrow-right",
      "hashedName": "blue-arrow-right.1846b76935a1",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/blue-arrow-right.png",
        "hashedPath": "images/rd/suffixed/blue-arrow-right.1846b76935a1.png"
      }
    },
    "car-icon-blue.png": {
      "name": "car-icon-blue",
      "hashedName": "car-icon-blue.f7592d05a3f0",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/car-icon-blue.png",
        "hashedPath": "images/rd/suffixed/car-icon-blue.f7592d05a3f0.png"
      }
    },
    "car-icon-white.png": {
      "name": "car-icon-white",
      "hashedName": "car-icon-white.ebeec496cd48",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/car-icon-white.png",
        "hashedPath": "images/rd/suffixed/car-icon-white.ebeec496cd48.png"
      }
    },
    "convert-icon-blue.png": {
      "name": "convert-icon-blue",
      "hashedName": "convert-icon-blue.4ca3d29d3d8c",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/convert-icon-blue.png",
        "hashedPath": "images/rd/suffixed/convert-icon-blue.4ca3d29d3d8c.png"
      }
    },
    "convert-icon-white.png": {
      "name": "convert-icon-white",
      "hashedName": "convert-icon-white.b46d4998e7d8",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/convert-icon-white.png",
        "hashedPath": "images/rd/suffixed/convert-icon-white.b46d4998e7d8.png"
      }
    },
    "auth-failed.svg": {
      "name": "auth-failed",
      "hashedName": "auth-failed.7c2dd451a923",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/auth-failed.svg",
        "hashedPath": "images/rd/errors/suffixed/auth-failed.7c2dd451a923.svg"
      }
    },
    "id-error.svg": {
      "name": "id-error",
      "hashedName": "id-error.e9ece0299c93",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/id-error.svg",
        "hashedPath": "images/rd/errors/suffixed/id-error.e9ece0299c93.svg"
      }
    },
    "otp-error.svg": {
      "name": "otp-error",
      "hashedName": "otp-error.8ed89961fd20",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/otp-error.svg",
        "hashedPath": "images/rd/errors/suffixed/otp-error.8ed89961fd20.svg"
      }
    },
    "page-error.png": {
      "name": "page-error",
      "hashedName": "page-error.55c275100307",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/errors/page-error.png",
        "hashedPath": "images/rd/errors/suffixed/page-error.55c275100307.png"
      }
    },
    "payment-failed.svg": {
      "name": "payment-failed",
      "hashedName": "payment-failed.30d8d5985c71",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/payment-failed.svg",
        "hashedPath": "images/rd/errors/suffixed/payment-failed.30d8d5985c71.svg"
      }
    },
    "supplier-error.svg": {
      "name": "supplier-error",
      "hashedName": "supplier-error.0ca2b0870918",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/supplier-error.svg",
        "hashedPath": "images/rd/errors/suffixed/supplier-error.0ca2b0870918.svg"
      }
    },
    "timeout.svg": {
      "name": "timeout",
      "hashedName": "timeout.d2b8f18064e0",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/timeout.svg",
        "hashedPath": "images/rd/errors/suffixed/timeout.d2b8f18064e0.svg"
      }
    },
    "unexpected-error.svg": {
      "name": "unexpected-error",
      "hashedName": "unexpected-error.b2045b4b78e2",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/errors/unexpected-error.svg",
        "hashedPath": "images/rd/errors/suffixed/unexpected-error.b2045b4b78e2.svg"
      }
    },
    "flight-icon-blue.png": {
      "name": "flight-icon-blue",
      "hashedName": "flight-icon-blue.949c6786fbf3",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/flight-icon-blue.png",
        "hashedPath": "images/rd/suffixed/flight-icon-blue.949c6786fbf3.png"
      }
    },
    "flight-icon-white.png": {
      "name": "flight-icon-white",
      "hashedName": "flight-icon-white.b007be66e3a9",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/flight-icon-white.png",
        "hashedPath": "images/rd/suffixed/flight-icon-white.b007be66e3a9.png"
      }
    },
    "footer-logo.png": {
      "name": "footer-logo",
      "hashedName": "footer-logo.9837418cd4d2",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/footer-logo.png",
        "hashedPath": "images/rd/suffixed/footer-logo.9837418cd4d2.png"
      }
    },
    "giftcard-icon-blue.png": {
      "name": "giftcard-icon-blue",
      "hashedName": "giftcard-icon-blue.a6dd42cd2a86",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/giftcard-icon-blue.png",
        "hashedPath": "images/rd/suffixed/giftcard-icon-blue.a6dd42cd2a86.png"
      }
    },
    "giftcard-icon-white.png": {
      "name": "giftcard-icon-white",
      "hashedName": "giftcard-icon-white.791ac6309a98",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/giftcard-icon-white.png",
        "hashedPath": "images/rd/suffixed/giftcard-icon-white.791ac6309a98.png"
      }
    },
    "grey-arrow-down.png": {
      "name": "grey-arrow-down",
      "hashedName": "grey-arrow-down.d9417311175f",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/grey-arrow-down.png",
        "hashedPath": "images/rd/suffixed/grey-arrow-down.d9417311175f.png"
      }
    },
    "header-logo.svg": {
      "name": "header-logo",
      "hashedName": "header-logo.e6b5cfa275a2",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/header-logo.svg",
        "hashedPath": "images/rd/suffixed/header-logo.e6b5cfa275a2.svg"
      }
    },
    "hotel-icon-blue.png": {
      "name": "hotel-icon-blue",
      "hashedName": "hotel-icon-blue.7fa8b42c7576",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/hotel-icon-blue.png",
        "hashedPath": "images/rd/suffixed/hotel-icon-blue.7fa8b42c7576.png"
      }
    },
    "hotel-icon-white.png": {
      "name": "hotel-icon-white",
      "hashedName": "hotel-icon-white.cbf69eceb8fa",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/hotel-icon-white.png",
        "hashedPath": "images/rd/suffixed/hotel-icon-white.cbf69eceb8fa.png"
      }
    },
    "icn-transfer.svg": {
      "name": "icn-transfer",
      "hashedName": "icn-transfer.3f2200437e5b",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd/icn-transfer.svg",
        "hashedPath": "images/rd/suffixed/icn-transfer.3f2200437e5b.svg"
      }
    },
    "more-icon-blue.png": {
      "name": "more-icon-blue",
      "hashedName": "more-icon-blue.811edc0e6b08",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/more-icon-blue.png",
        "hashedPath": "images/rd/suffixed/more-icon-blue.811edc0e6b08.png"
      }
    },
    "more-icon-white.png": {
      "name": "more-icon-white",
      "hashedName": "more-icon-white.f5ec2a417f1c",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/more-icon-white.png",
        "hashedPath": "images/rd/suffixed/more-icon-white.f5ec2a417f1c.png"
      }
    },
    "red-arrow-down.png": {
      "name": "red-arrow-down",
      "hashedName": "red-arrow-down.e19469b3682b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/red-arrow-down.png",
        "hashedPath": "images/rd/suffixed/red-arrow-down.e19469b3682b.png"
      }
    },
    "star-icon-white.png": {
      "name": "star-icon-white",
      "hashedName": "star-icon-white.aaf25cb2db97",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/star-icon-white.png",
        "hashedPath": "images/rd/suffixed/star-icon-white.aaf25cb2db97.png"
      }
    },
    "star-icon-yellow.png": {
      "name": "star-icon-yellow",
      "hashedName": "star-icon-yellow.2cb1051e76b8",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/star-icon-yellow.png",
        "hashedPath": "images/rd/suffixed/star-icon-yellow.2cb1051e76b8.png"
      }
    },
    "transfer-icon-grey.png": {
      "name": "transfer-icon-grey",
      "hashedName": "transfer-icon-grey.d5f63e2dd5e4",
      "extension": "png",
      "path": {
        "originalPath": "images/rd/transfer-icon-grey.png",
        "hashedPath": "images/rd/suffixed/transfer-icon-grey.d5f63e2dd5e4.png"
      }
    },
    "vma-loader.gif": {
      "name": "vma-loader",
      "hashedName": "vma-loader.8e99d675ba47",
      "extension": "gif",
      "path": {
        "originalPath": "images/rd/vma-loader.gif",
        "hashedPath": "images/rd/suffixed/vma-loader.8e99d675ba47.gif"
      }
    },
    "rd-arrow-left.png": {
      "name": "rd-arrow-left",
      "hashedName": "rd-arrow-left.4440685632e2",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-arrow-left.png",
        "hashedPath": "images/suffixed/rd-arrow-left.4440685632e2.png"
      }
    },
    "rd-arrow-right.png": {
      "name": "rd-arrow-right",
      "hashedName": "rd-arrow-right.8c5ea704b133",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-arrow-right.png",
        "hashedPath": "images/suffixed/rd-arrow-right.8c5ea704b133.png"
      }
    },
    "rd-back-arrow.png": {
      "name": "rd-back-arrow",
      "hashedName": "rd-back-arrow.513594f85017",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-back-arrow.png",
        "hashedPath": "images/suffixed/rd-back-arrow.513594f85017.png"
      }
    },
    "rd-banner-acme.jpg": {
      "name": "rd-banner-acme",
      "hashedName": "rd-banner-acme.49f6a6a7d920",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-banner-acme.jpg",
        "hashedPath": "images/suffixed/rd-banner-acme.49f6a6a7d920.jpg"
      }
    },
    "rd-burger-icon.png": {
      "name": "rd-burger-icon",
      "hashedName": "rd-burger-icon.78fcb3791f73",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-burger-icon.png",
        "hashedPath": "images/suffixed/rd-burger-icon.78fcb3791f73.png"
      }
    },
    "rd-car-icon-blue.png": {
      "name": "rd-car-icon-blue",
      "hashedName": "rd-car-icon-blue.e1ae511e7d11",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-car-icon-blue.png",
        "hashedPath": "images/suffixed/rd-car-icon-blue.e1ae511e7d11.png"
      }
    },
    "rd-convert-icon-blue.png": {
      "name": "rd-convert-icon-blue",
      "hashedName": "rd-convert-icon-blue.a545a8c44ba1",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-convert-icon-blue.png",
        "hashedPath": "images/suffixed/rd-convert-icon-blue.a545a8c44ba1.png"
      }
    },
    "rd-down-redarrow.png": {
      "name": "rd-down-redarrow",
      "hashedName": "rd-down-redarrow.ad10b4941891",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-down-redarrow.png",
        "hashedPath": "images/suffixed/rd-down-redarrow.ad10b4941891.png"
      }
    },
    "rd-down-whitearrow.png": {
      "name": "rd-down-whitearrow",
      "hashedName": "rd-down-whitearrow.eac85beec6e7",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-down-whitearrow.png",
        "hashedPath": "images/suffixed/rd-down-whitearrow.eac85beec6e7.png"
      }
    },
    "rd-emailsent-state-icon.png": {
      "name": "rd-emailsent-state-icon",
      "hashedName": "rd-emailsent-state-icon.f45f81e1913f",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-emailsent-state-icon.png",
        "hashedPath": "images/suffixed/rd-emailsent-state-icon.f45f81e1913f.png"
      }
    },
    "rd-empty-expire-points.png": {
      "name": "rd-empty-expire-points",
      "hashedName": "rd-empty-expire-points.662a9be89752",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-empty-expire-points.png",
        "hashedPath": "images/suffixed/rd-empty-expire-points.662a9be89752.png"
      }
    },
    "rd-equal-icon.svg": {
      "name": "rd-equal-icon",
      "hashedName": "rd-equal-icon.aa40bb307cab",
      "extension": "svg",
      "path": {
        "originalPath": "images/rd-equal-icon.svg",
        "hashedPath": "images/suffixed/rd-equal-icon.aa40bb307cab.svg"
      }
    },
    "rd-faq-icon-desktop.png": {
      "name": "rd-faq-icon-desktop",
      "hashedName": "rd-faq-icon-desktop.77e16da199bd",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-faq-icon-desktop.png",
        "hashedPath": "images/suffixed/rd-faq-icon-desktop.77e16da199bd.png"
      }
    },
    "rd-faq-icon-mobile.png": {
      "name": "rd-faq-icon-mobile",
      "hashedName": "rd-faq-icon-mobile.b60b1361fd31",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-faq-icon-mobile.png",
        "hashedPath": "images/suffixed/rd-faq-icon-mobile.b60b1361fd31.png"
      }
    },
    "rd-flight-icon-blue.png": {
      "name": "rd-flight-icon-blue",
      "hashedName": "rd-flight-icon-blue.1f47b174c7c0",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-flight-icon-blue.png",
        "hashedPath": "images/suffixed/rd-flight-icon-blue.1f47b174c7c0.png"
      }
    },
    "rd-giftcard-icon-blue.png": {
      "name": "rd-giftcard-icon-blue",
      "hashedName": "rd-giftcard-icon-blue.0d97ff62c58b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-giftcard-icon-blue.png",
        "hashedPath": "images/suffixed/rd-giftcard-icon-blue.0d97ff62c58b.png"
      }
    },
    "rd-grab-logo.png": {
      "name": "rd-grab-logo",
      "hashedName": "rd-grab-logo.6b17ae0774bd",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-grab-logo.png",
        "hashedPath": "images/suffixed/rd-grab-logo.6b17ae0774bd.png"
      }
    },
    "rd-hotel-icon-blue.png": {
      "name": "rd-hotel-icon-blue",
      "hashedName": "rd-hotel-icon-blue.ab82bbf29d3a",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-hotel-icon-blue.png",
        "hashedPath": "images/suffixed/rd-hotel-icon-blue.ab82bbf29d3a.png"
      }
    },
    "rd-krisflyer-logo.png": {
      "name": "rd-krisflyer-logo",
      "hashedName": "rd-krisflyer-logo.424c2aabc9be",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-krisflyer-logo.png",
        "hashedPath": "images/suffixed/rd-krisflyer-logo.424c2aabc9be.png"
      }
    },
    "rd-lazada-logo.png": {
      "name": "rd-lazada-logo",
      "hashedName": "rd-lazada-logo.e8b9d851909d",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-lazada-logo.png",
        "hashedPath": "images/suffixed/rd-lazada-logo.e8b9d851909d.png"
      }
    },
    "rd-more-icon-blue.png": {
      "name": "rd-more-icon-blue",
      "hashedName": "rd-more-icon-blue.4c8bb5c4f3eb",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-more-icon-blue.png",
        "hashedPath": "images/suffixed/rd-more-icon-blue.4c8bb5c4f3eb.png"
      }
    },
    "rd-myprofile-icon.png": {
      "name": "rd-myprofile-icon",
      "hashedName": "rd-myprofile-icon.2908a78d0a62",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-myprofile-icon.png",
        "hashedPath": "images/suffixed/rd-myprofile-icon.2908a78d0a62.png"
      }
    },
    "rd-notif-icon-white.png": {
      "name": "rd-notif-icon-white",
      "hashedName": "rd-notif-icon-white.b3c5bde1f0be",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-notif-icon-white.png",
        "hashedPath": "images/suffixed/rd-notif-icon-white.b3c5bde1f0be.png"
      }
    },
    "rd-pagination-active.png": {
      "name": "rd-pagination-active",
      "hashedName": "rd-pagination-active.67ee464fd31b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-pagination-active.png",
        "hashedPath": "images/suffixed/rd-pagination-active.67ee464fd31b.png"
      }
    },
    "rd-pagination-inactive.png": {
      "name": "rd-pagination-inactive",
      "hashedName": "rd-pagination-inactive.489bc9c73cda",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-pagination-inactive.png",
        "hashedPath": "images/suffixed/rd-pagination-inactive.489bc9c73cda.png"
      }
    },
    "rd-photos-booking-priority.jpg": {
      "name": "rd-photos-booking-priority",
      "hashedName": "rd-photos-booking-priority.92c0132ef08c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-booking-priority.jpg",
        "hashedPath": "images/suffixed/rd-photos-booking-priority.92c0132ef08c.jpg"
      }
    },
    "rd-photos-box-office-access.jpg": {
      "name": "rd-photos-box-office-access",
      "hashedName": "rd-photos-box-office-access.3bcb0022c25a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-box-office-access.jpg",
        "hashedPath": "images/suffixed/rd-photos-box-office-access.3bcb0022c25a.jpg"
      }
    },
    "rd-photos-gourmet.jpg": {
      "name": "rd-photos-gourmet",
      "hashedName": "rd-photos-gourmet.1f7208e27856",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-gourmet.jpg",
        "hashedPath": "images/suffixed/rd-photos-gourmet.1f7208e27856.jpg"
      }
    },
    "rd-photos-helicopter.jpg": {
      "name": "rd-photos-helicopter",
      "hashedName": "rd-photos-helicopter.3bcb0022c25a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-helicopter.jpg",
        "hashedPath": "images/suffixed/rd-photos-helicopter.3bcb0022c25a.jpg"
      }
    },
    "rd-photos-opera.jpg": {
      "name": "rd-photos-opera",
      "hashedName": "rd-photos-opera.92c0132ef08c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd-photos-opera.jpg",
        "hashedPath": "images/suffixed/rd-photos-opera.92c0132ef08c.jpg"
      }
    },
    "rd-points-transaction-icon.png": {
      "name": "rd-points-transaction-icon",
      "hashedName": "rd-points-transaction-icon.7c917cf624f4",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-points-transaction-icon.png",
        "hashedPath": "images/suffixed/rd-points-transaction-icon.7c917cf624f4.png"
      }
    },
    "rd-redarrow-down.png": {
      "name": "rd-redarrow-down",
      "hashedName": "rd-redarrow-down.4ad15108980a",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-redarrow-down.png",
        "hashedPath": "images/suffixed/rd-redarrow-down.4ad15108980a.png"
      }
    },
    "rd-redarrow-down2.png": {
      "name": "rd-redarrow-down2",
      "hashedName": "rd-redarrow-down2.e19469b3682b",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-redarrow-down2.png",
        "hashedPath": "images/suffixed/rd-redarrow-down2.e19469b3682b.png"
      }
    },
    "rd-search-icon.png": {
      "name": "rd-search-icon",
      "hashedName": "rd-search-icon.9606fa74d8df",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-search-icon.png",
        "hashedPath": "images/suffixed/rd-search-icon.9606fa74d8df.png"
      }
    },
    "rd-travel-booking-icon.png": {
      "name": "rd-travel-booking-icon",
      "hashedName": "rd-travel-booking-icon.a40fac2390aa",
      "extension": "png",
      "path": {
        "originalPath": "images/rd-travel-booking-icon.png",
        "hashedPath": "images/suffixed/rd-travel-booking-icon.a40fac2390aa.png"
      }
    },
    "rd_banner.jpg": {
      "name": "rd_banner",
      "hashedName": "rd_banner.f2d60c362985",
      "extension": "jpg",
      "path": {
        "originalPath": "images/rd_banner.jpg",
        "hashedPath": "images/suffixed/rd_banner.f2d60c362985.jpg"
      }
    },
    "share-points-tile.jpg": {
      "name": "share-points-tile",
      "hashedName": "share-points-tile.879cb150ca3a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/share-points-tile.jpg",
        "hashedPath": "images/suffixed/share-points-tile.879cb150ca3a.jpg"
      }
    },
    "share-points.avif": {
      "name": "share-points",
      "hashedName": "share-points.4096fc4c5417",
      "extension": "avif",
      "path": {
        "originalPath": "images/share-points.avif",
        "hashedPath": "images/suffixed/share-points.4096fc4c5417.avif"
      }
    },
    "share-points.jpg": {
      "name": "share-points",
      "hashedName": "share-points.879cb150ca3a",
      "extension": "jpg",
      "path": {
        "originalPath": "images/share-points.jpg",
        "hashedPath": "images/suffixed/share-points.879cb150ca3a.jpg"
      }
    },
    "share-points.webp": {
      "name": "share-points",
      "hashedName": "share-points.1f737b431157",
      "extension": "webp",
      "path": {
        "originalPath": "images/share-points.webp",
        "hashedPath": "images/suffixed/share-points.1f737b431157.webp"
      }
    },
    "tc-tile.jpg": {
      "name": "tc-tile",
      "hashedName": "tc-tile.da6e3d09bad1",
      "extension": "jpg",
      "path": {
        "originalPath": "images/tc-tile.jpg",
        "hashedPath": "images/suffixed/tc-tile.da6e3d09bad1.jpg"
      }
    },
    "te-tile.jpg": {
      "name": "te-tile",
      "hashedName": "te-tile.edbd92e51c1c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/te-tile.jpg",
        "hashedPath": "images/suffixed/te-tile.edbd92e51c1c.jpg"
      }
    },
    "virgin-money-card-rewards.jpg": {
      "name": "virgin-money-card-rewards",
      "hashedName": "virgin-money-card-rewards.f64c076eab3c",
      "extension": "jpg",
      "path": {
        "originalPath": "images/virgin-money-card-rewards.jpg",
        "hashedPath": "images/suffixed/virgin-money-card-rewards.f64c076eab3c.jpg"
      }
    },
    "virginperks-tile.jpg": {
      "name": "virginperks-tile",
      "hashedName": "virginperks-tile.b431b23c9536",
      "extension": "jpg",
      "path": {
        "originalPath": "images/virginperks-tile.jpg",
        "hashedPath": "images/suffixed/virginperks-tile.b431b23c9536.jpg"
      }
    },
    "vma-campaign-banner.avif": {
      "name": "vma-campaign-banner",
      "hashedName": "vma-campaign-banner.79014df69dfa",
      "extension": "avif",
      "path": {
        "originalPath": "images/vma-campaign-banner.avif",
        "hashedPath": "images/suffixed/vma-campaign-banner.79014df69dfa.avif"
      }
    },
    "vma-campaign-banner.jpg": {
      "name": "vma-campaign-banner",
      "hashedName": "vma-campaign-banner.08c90952e4d1",
      "extension": "jpg",
      "path": {
        "originalPath": "images/vma-campaign-banner.jpg",
        "hashedPath": "images/suffixed/vma-campaign-banner.08c90952e4d1.jpg"
      }
    },
    "vma-campaign-banner.webp": {
      "name": "vma-campaign-banner",
      "hashedName": "vma-campaign-banner.2c150b9a80f2",
      "extension": "webp",
      "path": {
        "originalPath": "images/vma-campaign-banner.webp",
        "hashedPath": "images/suffixed/vma-campaign-banner.2c150b9a80f2.webp"
      }
    }
  },
  "i18n": {
    "en-AU.json": {
      "name": "en-AU",
      "hashedName": "en-AU.e80e5b4c801f",
      "extension": "json",
      "path": {
        "originalPath": "i18n/en-AU.json",
        "hashedPath": "i18n/suffixed/en-AU.e80e5b4c801f.json"
      }
    },
    "en-GB.json": {
      "name": "en-GB",
      "hashedName": "en-GB.9128ef911c3a",
      "extension": "json",
      "path": {
        "originalPath": "i18n/en-GB.json",
        "hashedPath": "i18n/suffixed/en-GB.9128ef911c3a.json"
      }
    },
    "en-US.json": {
      "name": "en-US",
      "hashedName": "en-US.094133cac0b2",
      "extension": "json",
      "path": {
        "originalPath": "i18n/en-US.json",
        "hashedPath": "i18n/suffixed/en-US.094133cac0b2.json"
      }
    }
  }
} 

export type AssetMap = typeof assetMap